import sr1performanceeDefaults from '../sr1performance/config.js';
import westcoastcorvettesDefaults from '../westcoastcorvettes/config.js';
import shopifyGenericDefaults from '../shopify-generic/config.js';

export default {
  ...sr1performanceeDefaults,
  ...westcoastcorvettesDefaults,
  includes: ['shopify-generic', 'sr1performance', 'westcoastcorvettes'],
  Widgets: [
    ...shopifyGenericDefaults.Widgets,
    {
      name: 'SearchBoxMobile',
      type: 'SearchBox',
      location: '#cm-mobile-search',
      template: 'SearchBox',
    },
  ],
};
